import { render, staticRenderFns } from "./TopPlatformTab.vue?vue&type=template&id=cf10d87a&scoped=true"
import script from "./TopPlatformTab.vue?vue&type=script&lang=js"
export * from "./TopPlatformTab.vue?vue&type=script&lang=js"
import style0 from "./TopPlatformTab.vue?vue&type=style&index=0&id=cf10d87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf10d87a",
  null
  
)

/* custom blocks */
import block0 from "./TopPlatformTab.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports